import {Flux} from '@nlabs/arkhamjs';
import {FluxProvider} from '@nlabs/arkhamjs-utils-react';
import {useEffect, useState} from 'react';

import {SiteApp} from '../SiteApp/SiteApp.js';
import {ThemeProvider} from '../ThemeProvider/ThemeProvider.js';

import type {ReactElement} from 'react';

let initialized: Promise<unknown> | undefined;

export const WorkspaceProvider = (): ReactElement => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let mounted = true;
    initialized ||= (async () => {
      if(!Flux.isInit) {
        await Flux.init({name: 'reactorbox'});
      }
      await Flux.setState('app.config', {app: {api: {public: '/api', url: '/api'}, name: 'Reactorbox', rum: {enabled: false}}});
    })();
    void initialized.then(() => {
      if(mounted) {
        setReady(true);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);
  return <FluxProvider flux={Flux}>{ready ? <ThemeProvider><SiteApp /></ThemeProvider> : <div className="grid min-h-dvh place-items-center bg-black font-sans text-sm text-white/60">Opening your studio…</div>}</FluxProvider>;
};
